import React from "react";

const width = window.innerWidth;
const getWidthEmail = () => {
    switch (width){
        case 1920:
            return 308
        case 1792:
            return 260
        case 1680:
            return 240
        case 1600:
            return 220
        case 1536:
            return 200
        case 1440:
            return 200
        case 1366:
            return 180
        default:
            return ""
    }
}
const getWidthWeighingStations= () => {
    switch (width){
        case 1920:
            return 560
        case 1792:
            return 540
        case 1680:
            return 520
        case 1600:
            return 460
        case 1536:
            return 430
        case 1440:
            return 300
        case 1366:
            return 250
        default:
            return ""
    }
}

const getWidthCustomerName= () => {
    switch (width){
        case 1920:
            return 222
        case 1792:
            return 200
        case 1680:
            return 180
        case 1600:
            return 170
        case 1536:
            return 150
        case 1440:
        case 1366:
            return 140
        default:
            return ""
    }
}
const getWidthPhoneNumber= () => {
    switch (width){
        case 1920:
            return 200
        case 1792:
            return 180
        case 1680:
        case 1600:
        case 1440:
        case 1536:
        case 1366:
            return 160
        default:
            return ""
    }
}
const getWidthNumber= () => {
    switch (width){
        case 1920:
        case 1792:
        case 1680:
            return 129
        case 1600:
        case 1536:
        case 1440:
        case 1366:
            return 119
        default:
            return ""
    }
}

export const columns = [
    {
        title: "Khách hàng",
        dataIndex: "customerName",
        width: getWidthCustomerName(),
        ellipsis: true,
    },
    {
        title: "Trạm cân",
        dataIndex: "weighingStations",
        ellipsis: true,
        width: getWidthWeighingStations(),
        onCell: record => {
            return {
                onClick: event => {
                    event.stopPropagation();
                }
            }
        },
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        width: getWidthPhoneNumber(),
        ellipsis: true,
    },
    {
        title: "Email",
        dataIndex: "email",
        width: getWidthEmail(),
        ellipsis: true,
    },
    {
        title: "Số Trạm cân",
        dataIndex: "numberWeighingStations",
        width : getWidthNumber(),
        align: "right",
        className: "padding_xo"
    },
    {
        title: "Số tài khoản",
        dataIndex: "numberAccount",
        width: getWidthNumber(),
        align: "right",
        className: "padding_lo"
    }
];
